module.exports = "https://static.energy5.com/_next/static/images/energy-525e5da00c2ab2672ea7febdcdeb3d72.png";